import React, { Component } from 'react';

export default class Header extends Component {
  render() {
    return (
      <div className="header bg-dark rounded text-white">
        <h1>our team</h1>
      </div>
    );
  }
}
